export const Role = {
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
  SALES: "Sales",
  RECRUITER: "Recruiter",
};
